<template>
  <div>
    <el-row :gutter="20">
      <!--      <el-col :span="3">-->
      <!--        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%">去开卡</el-button>-->
      <!--      </el-col>-->
<!--      <el-col :span="5">-->
<!--        <el-input placeholder="members表id" v-model="params.members_id" style="width: 100%">-->
<!--          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>-->
<!--        </el-input>-->
<!--      </el-col>-->
      <el-col :span="5">
        <el-input placeholder="会员id" v-model="params.user_id" style="width: 100%">
          <el-button slot="append" icon="el-icon-search" @click="searchData"></el-button>
        </el-input>
      </el-col>
      <el-col :md="10" :lg="8">
        <el-date-picker v-model="time_create" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" size="mini"></el-date-picker>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="exportData" v-loading="exportloading">导出</el-button>
      </el-col>

    </el-row>
    <el-table :data="userList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="user_id" label="会员id" width="250">
        <template slot-scope="scope">
          {{scope.row.user_id}}
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" width="250">
        <template slot-scope="scope">
          {{scope.row.mobile}}
        </template>
      </el-table-column>
      <el-table-column prop="来源" label="来源" width="250">
        <template slot-scope="scope">
         人保
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="250">
        <template slot-scope="scope">
          {{scope.row.create_time}}
        </template>
      </el-table-column>
      <el-table-column prop="num" label="订单数量" width="250">
        <template slot-scope="scope">
          {{scope.row.num}}
        </template>
      </el-table-column>
      <el-table-column prop="item_fee" label="订单金额" width="250">
        <template slot-scope="scope">
          {{scope.row.price}}
        </template>
      </el-table-column>


<!--      <el-table-column prop="item_price" label="金额" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.item_price}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="zhongan_heshu" label="众安盒数" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.zhongan_heshu}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="service_price" label="服务费" width="250">-->
<!--      <template slot-scope="scope">-->
<!--        {{scope.row.service_price}}-->
<!--      </template>-->
<!--    </el-table-column>-->
<!--      <el-table-column prop="distributor_number" label="门店号" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.distributor_number}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="create_time" label="时间" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.create_time}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="item_spec_desc" label="商品规格" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.item_spec_desc}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="is_sync" label="是否同步" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.is_sync}}-->
<!--        </template>-->
<!--      </el-table-column>-->

      <!--      <el-table-column label="操作">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div class="operating-icons">-->
      <!--            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>-->
      <!--            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
<!--      <el-table-column prop="userNo" label="众安那边给到的用户编号" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.userNo}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="sex" label="性别" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.sex}}-->
<!--        </template>-->
<!--      </el-table-column>-->

<!--      <el-table-column prop="time" label="领取卡券的时间" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.time}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="操作" width="380">-->
<!--        <template slot-scope="scope">-->

<!--          <el-button type="text" @click="editAction(scope.$index, scope.row)" >拉取订单</el-button>-->


<!--          &lt;!&ndash;          <el-button type="text" @click="editAction(scope.$index, scope.row)" v-if="scope.row.employee==''">编辑</el-button>&ndash;&gt;-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="pharmacistTel" label="签名图片地址" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.sign_url}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="openId" label="openId" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.openId}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="unionid" label="unionid" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.unionid}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="res" label="结果" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.res}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="msg" label="提示" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.msg}}-->
<!--        </template>-->
<!--      </el-table-column>-->

<!--      <el-table-column prop="createdate" label="创建时间" width="250">-->
<!--        <template slot-scope="scope">-->
<!--          {{scope.row.createdate}}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="操作">-->
<!--        <template slot-scope="scope">-->
<!--          <div v-if="scope.row.res=='false'">-->
<!--            <div class="operating-icons">-->
<!--              <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>-->
<!--              &lt;!&ndash;            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>&ndash;&gt;-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->

<!--      </el-table-column>-->


    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :total="total_count" :page-size="params.page_size">
      </el-pagination>
    </div>
<!--    <el-dialog title="添加推荐人" width="40%" :visible.sync="employeeDialog" :before-close="handleCancelLabelsDialog">-->
<!--      <template>-->
<!--        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">-->


<!--          <el-form-item class="content-left" label="日期" prop="time">-->

<!--            <el-input placeholder="拉取日期" v-model="form.time"></el-input>-->
<!--          </el-form-item>-->

<!--          <el-form-item class="content-center">-->
<!--            <el-button type="primary" @click="saveTimeData">确定保存</el-button>-->
<!--          </el-form-item>-->
<!--        </el-form>-->
<!--      </template>-->
<!--    </el-dialog>-->
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  // eslint-disable-next-line no-unused-vars
  import {Message} from 'element-ui'
  // eslint-disable-next-line no-unused-vars
  import {
    RenbaoList,
    pullOrder,
    RenbaoExport,

  } from '../../../api/baoxian'

  export default {
    data() {
      return {
        time_create:'',
        isEdit: false,
        userList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          page_size: 20,
          card: '',
          employee_id: '',
          pharmacistTel: '',
          phone: '',
          store_inkid: ''

        },

        resList: [{label: 'true', value: 'true'},
          {label: 'false', value: 'false'}
        ],
        form: {
          id: '',

          description: ''
        },

        employeeDialog: false,
        predefineColors: ['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      saveTimeData() {
        this.employeeDialog = false
        if (this.form.id) {
          // eslint-disable-next-line no-undef
          pullOrder(this.form).then(res => {

              this.$message({
                type: 'success',
                message: '获取成功'
              })
              this.getDataList()

          })
        } else {
          this.$message.error('缺少Id')
          this.getDataList()
        }
      },
      exportData() {
        this.exportloading = true
        this.params.export = 1
        RenbaoExport(this.params).then(res => {
          this.exportloading = false
          console.log(res.status==200)
          if (res.status) {
            this.$message({
              type: 'success',
              message: '已加入执行队列，请在设置-导出列表中下载'
            })
            return
          } else if (res.data.data.url) {
            this.downloadUrl = res.data.url
            this.downloadName = res.data.filename
            this.downloadView = true
          } else {
            this.$message({
              type: 'error',
              message: '无内容可导出 或 执行失败，请检查重试'
            })
            return
          }
        }).catch(error => {
          this.exportloading = false
        })
      },
      // eslint-disable-next-line camelcase
      handleCurrentChange(page_num) {
        // eslint-disable-next-line camelcase
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate() { // 添加
        this.employeeDialog = true
        // eslint-disable-next-line standard/object-curly-even-spacing
        this.form = {tag_id: '', tag_name: '', tag_color: '#ff1939', font_color: '#ffffff', description: ''}
      },
      editAction(index, row) { // 编辑
        this.form = row
        this.employeeDialog = true
      },
      preview(index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData() {

          this.params.page = 1
          this.getDataList()

      },
      getDataList() {
        this.loading = true
        RenbaoList(this.params).then(response => {
          this.userList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
          // eslint-disable-next-line handle-callback-err
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },

      getTaskTime(strDate) {
        let date = new Date(strDate)
        let y = date.getFullYear()
        let m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let str = y + '-' + m + '-' + d
        return str
      },
      getTimeStr(date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog() {
        this.employeeDialog = false
      },
      dateChange (val) {
        console.log(val)

        if (val.length > 0) {
          this.time_start_begin = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.time_start_end = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
          this.params.time_start_begin = this.time_start_begin
          this.params.time_start_end = this.time_start_end
        } else {
          this.time_start_begin = ''
          this.time_start_end = ''
          this.params.time_start_begin = ''
          this.params.time_start_end = ''
        }
        this.params.page = 1

        this.getDataList()
      },
      dateStrToTimeStamp (str) {
        return Date.parse(new Date(str))/1000
      },
    },

    mounted() {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    img {
      width: 90%;
    }
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #99a9bf;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 10px;

    img {
      width: 90%;
    }
  }

  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }

  .service-label .el-checkbox:first-child {
    margin-left: 15px;
  }

  .service-label .el-input:first-child {
    margin-left: 15px;
  }

  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }

  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100% !important;
    }

    img {
      width: 100%;
    }
  }

  .grid-attribute {
    table {
      width: 100% !important;
    }
  }
</style>



// WEBPACK FOOTER //
// user.vue?1e099c60